// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_bzK","cls2":"ReferenceEvaluationPage-cls2_lqO ReferenceEvaluationPage-cls1_bzK"};